
























































import { teamMembersClient } from '../api/clients.context'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { AddMemberModel } from '@/components/api/api.clients'

@Component({})
export default class PlayerCreateVue extends Vue {
  @Prop({ type: String, required: true })
  teamId: string = ''

  @Prop({ type: String })
  defaultYear: number = 2011

  year: number = 2010
  email: string | null = null
  username: string | null = null

  locale = {
      firstDayOfWeek: 0,
      dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dzcember'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'Today',
      clear: 'Clear',
      dateFormat: 'dd.mm.yy',
      weekHeader: 'Wk'
  }

  mounted () {
      this.year = this.defaultYear
  }

  async createPlayer () {
      if (this.teamId != null && this.username != null && this.username.length > 0 && this.year != null) {
          const year = this.year
          var mail: string = ''
          if (this.email != null) {
              mail = this.email
          }
          if (year > 2000) {
              const model: AddMemberModel = { displayName: this.username, ageGroup: year, emailAddress: mail }
              try {
                  await teamMembersClient.createAndAddMember(this.teamId, model)
                  this.username = null
              } catch (ex) {
                  console.log(ex)
              }
              this.$emit('saved', model)
          }
      }
  }

  async cancelPlayerCreation () {
      this.$emit('canceled')
  }
}

